module.exports = __webpack_public_path__ + "img/team.bac8b612.svg";